// extracted by mini-css-extract-plugin
module.exports = {"theme":"prism-module--theme--1x3ul text-monospace","dark":"prism-module--dark--2hPR3","light":"prism-module--light--2Bp_M"};